module.exports = __webpack_public_path__ + "img/chama_azul.25da442f.jpg";